<template>
  <div id="app">
    <router-view />
    <cfooter v-if="!$route.path.includes('payMent')"></cfooter>
  </div>
</template>

<style>
#app {
  width: 75%;
  min-width: 1200px;
  margin: 0 auto;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  /* overflow-x: scroll; */
}
</style>

<script>
import cfooter from "@/components/footer/index.vue";
export default {
  name: "App",
  mounted() {
    this.getInfo();
    console.log(this.$store.state.user);
  },
  methods: {
    getInfo() {
      var _this = this;
      
      if (!this.$store.state.user.id) {
        return;
      }
      this.$http
        .get("/api/user/getInfo", { params: { userId: this.$store.state.user.id } })
        .then((res) => {
          localStorage.setItem("userStatus", res.data.data.status);
          localStorage.setItem("vipEndDate", res.data.data.vipEndDate);
          console.log(localStorage.getItem("userStatus"), "状态");
          if (res.data.data.status == 2) {
            if(window.location.href.includes('payMent')) {
              return;
            }
            _this.$confirm("当前账号已到期，请去支付页面续费后使用", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
                showCancelButton: false,
                closeOnClickModal: false,
                closeOnPressEscape: false,
                showClose: false,
              })
              .then(() => {
                setTimeout(() => {
                  _this.$router.push("/payMent");
                }, 1000);
              })
              .catch(() => {});
          }
        });
    },
  },
  watch: {
    // 监听路由变化
    $route(to, from) {
      console.log(to.path, "路由变化");
      if (!to.path.includes("payMent") || !to.path == "/") {
        this.getInfo();
      }
    },
  },
  components: {
    cfooter,
  },
};
</script>



// WEBPACK FOOTER //
// src/App.vue